import {
  LayoutGrid,
  MapPin,
  ShieldAlert,
  CalendarDays,
  Users,
  Building2,
  DollarSign,
  FileText,
  ScrollText,
  Settings,
  MessageSquare,
} from "lucide-react";
import type { NavigationSection } from "../types/navigationTypes";
import { PERMISSIONS } from "../config/permissions";

export const navigationSections: NavigationSection[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: LayoutGrid,
    path: "/",
  },
  {
    id: "live-map",
    label: "Live Map",
    icon: MapPin,
    path: "/live-map",
    permission: PERMISSIONS.GuardLocationsView,
  },
  {
    id: "incidents",
    label: "Incidents",
    icon: ShieldAlert,
    path: "/incidents",
  },
  {
    id: "scheduler",
    label: "Scheduler",
    icon: CalendarDays,
    path: "/scheduler",
    permission: PERMISSIONS.SchedulerShiftsView,
    subItems: [
      {
        id: "shift-calendar",
        label: "Calendar",
        path: "/scheduler",
        permission: PERMISSIONS.SchedulerShiftsView,
      },
      {
        id: "shift-templates",
        label: "Templates",
        path: "/scheduler/templates",
        permission: PERMISSIONS.SchedulerTemplatesView,
      },
      {
        id: "attendance",
        label: "Attendance",
        path: "/scheduler/attendance",
        permission: [PERMISSIONS.SchedulerAttendanceView, PERMISSIONS.OfficeTimeManage],
      },
      {
        id: "coverage-requests",
        label: "Coverage requests",
        path: "/coverage-requests",
        permission: PERMISSIONS.CoverageRequestsView,
      },
      {
        id: "overtime",
        label: "Overtime",
        path: "/scheduler/overtime",
        permission: PERMISSIONS.SchedulerShiftsView,
      },
      {
        id: "site-roster",
        label: "Site roster",
        path: "/scheduler/site-roster",
        permission: PERMISSIONS.SchedulerAttendanceView,
      },
    ],
  },
  {
    id: "employees",
    label: "Users",
    icon: Users,
    path: "/employees",
    permission: PERMISSIONS.EmployeesView,
  },
  {
    id: "clients",
    label: "Clients",
    icon: Building2,
    path: "/clients",
    permission: PERMISSIONS.ClientsView,
  },
  {
    id: "payroll",
    label: "Payroll",
    icon: DollarSign,
    path: "/payroll",
    permission: PERMISSIONS.PayrollView,
  },
  {
    id: "invoices",
    label: "Invoices",
    icon: FileText,
    path: "/invoices",
    permission: PERMISSIONS.FinanceView,
  },
  {
    id: "activity",
    label: "Activity Log",
    icon: ScrollText,
    path: "/activity",
    permission: PERMISSIONS.AuditView,
  },
  {
    id: "chat",
    label: "Chat",
    icon: MessageSquare,
    path: "/chat",
    permission: [PERMISSIONS.MessagingChat, PERMISSIONS.MessagingOps],
    permissionDeniedMessage:
      "Chat isn't enabled for your profile. Ask an administrator to add the Chat permission.",
    subItems: [
      { id: "chat-conversations", label: "Conversations", path: "/chat", permission: [PERMISSIONS.MessagingChat, PERMISSIONS.MessagingOps] },
      { id: "chat-broadcasts", label: "Broadcasts", path: "/chat/broadcasts", permission: PERMISSIONS.MessagingBroadcast },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    path: "/settings",
  },
];
